import React, { Component } from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Client } from "resourceModels";
import { getResource } from "selectors/resources";
import ModalSideBar from "components/Common/ModalSideBar";
import Button from "components/Common/Button";
import {
  setState as setStateAction,
  saveClientPlatform as saveClientPlatformAction,
  deletePlatform,
  updatePlatform as updatePlatformAction,
  saveClientAction
} from "actions";
import InstallationTab from "./SettingsPlatformChatModalInstallation";
import FunctionalityTab from "./SettingsPlatformChatModalFunctionality";
import ChatWindowTab from "./SettingsPlatformChatModalChatWindow";
import ChatButtonTab from "./SettingsPlatformChatModalChatButton";
import "./style.scss";

export class SettingsPlatformsChatModal extends Component {
  /**
   * @param {Object} props props
   */
  constructor(props) {
    super(props);

    const {
      /** @type Client */
      client
    } = this.props;

    this.onTabSelect = this.onTabSelect.bind(this);
    this.saveClientPlatform = this.saveClientPlatform.bind(this);

    this.state = {
      active: "installation"
    };

    /**
     * @constant
     * @type {Array}
     */
    this.BUTTONS = [
      {
        name: "installation",
        text: "Installation"
      },
      {
        name: "functionality",
        text: "Functionality"
      },
      {
        name: "chatWindow",
        text: "Chat Window"
      },
      {
        name: "chatButton",
        text: "Chat Button",
        visible: (
          client.features.get("matchClientBranding") ||
          client.features.get("tempMatchClientBranding")
        )
      }
    ];
  }

  /**
   * @param {Event} e - the onclick event data
   */
  onTabSelect(e) {
    this.setState({ active: e.target.title });
  }

  /**
   */
  saveClientPlatform() {
    const {
      /** @type Client */
      client,
      platform,
      saveClientPlatform,
      saveClient
    } = this.props;

    if (client.isDirty) {
      saveClient(client.id).then(() => {
        saveClientPlatform(platform);
      });
    } else {
      saveClientPlatform(platform);
    }
  }

  /**
   * @returns {React.Element} The react element to render in the content section
   */
  renderTab() {
    const { active } = this.state;
    const {
      /** @type Client */
      client,
      platform,
      platformType,
      setState,
      updatePlatform
    } = this.props;

    const tabProps = {
      client,
      platform,
      platformType,
      setState,
      updatePlatform
    };

    switch (active) {
      case "installation":
        return <InstallationTab />;

      case "functionality":
        return <FunctionalityTab {...tabProps} />;

      case "chatWindow":
        return (
          <ChatWindowTab
            platform={platform}
            platformType={platformType}
            updatePlatform={updatePlatform}
          />
        );

      case "chatButton":
        return (
          <ChatButtonTab
            platform={platform}
            platformType={platformType}
            updatePlatform={updatePlatform}
          />
        );

      default:
        return null;
    }
  }

  /**
   * @returns {React.Element}
   */
  render() {
    const { active } = this.state;
    const {
      /** @type Client */
      client,
      platform
    } = this.props;

    return (
      <div className="Modal__modal">
        <h5 className="Modal__title">Configure Web Chat</h5>
        <div className="Modal__body">
          <ModalSideBar
            buttons={this.BUTTONS}
            onClick={this.onTabSelect}
            activeButton={active}
          />
          <div className="Modal__body__container">
            {this.renderTab()}
            <div className="Modal__bottom Modal__bottom--right">
              <Button
                onClick={this.saveClientPlatform}
                title="Save Answer"
                text="Save"
                icon="Cloud"
                isLoading={false}
                disabled={(
                  (!platform.get("isDirty") && !client.isDirty) ||
                  !client.isValid
                )}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Ensure correct width of modal
SettingsPlatformsChatModal.isLarge = true;

/**
 * @param {Object} state
 * @param {Object} ownProps
 *
 * @returns {Object}
 */
function mapState(state, ownProps) {
  const { platforms } = state;

  return {
    client: getResource(state, "client"),
    platforms,
    platform: platforms.get(ownProps.platformType)
  };
}

/**
 * @param {Function} dispatch
 *
 * @returns {Object}
 */
function mapDispatch(dispatch) {
  return {
    ...bindActionCreators({
      setState: setStateAction,
      saveClientPlatform: saveClientPlatformAction,
      deletePlatform,
      updatePlatform: updatePlatformAction
    }, dispatch),
    saveClient: id => dispatch(saveClientAction(id))
  };
}

SettingsPlatformsChatModal.propTypes = {
  client: PropTypes.instanceOf(Client).isRequired,
  platform: ImmutablePropTypes.map.isRequired,
  platformType: PropTypes.string.isRequired,
  setState: PropTypes.func.isRequired,
  saveClientPlatform: PropTypes.func.isRequired,
  updatePlatform: PropTypes.func.isRequired,
  saveClient: PropTypes.func.isRequired
};

const Connector = connect(mapState, mapDispatch)(SettingsPlatformsChatModal);
export default Connector;
